// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__2GA77","footer":"ModalUpdate_footer__2tjZ7"};